import React, { useContext } from "react";
import { useUpdateUserMutation } from '../../redux/services/auth/registerAPI';
import { useFormik } from "formik";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from 'sweetalert2';
import { UserContext } from "../UserContext";

export default function UpdateUser({ handleUserChange }) {
  const { updateUserContext } = useContext(UserContext);
  const location = useLocation();
  const data = location;
  const [updateUser] = useUpdateUserMutation();
  const navigate = useNavigate();

  const form = useFormik({
    initialValues: {
      name: data?.state?.user?.name,
      family: data?.state?.user?.family,
      address: data?.state?.user?.address,
      email: data?.state?.user?.email
    },
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      const response = await updateUser({
        id: data?.state?.user?.id,
        name: values.name,
        family: values.family,
        address: values.address,
        email: values.email,
        mobile_number: data?.state?.user?.mobile_number,
        password: data?.state?.user?.password
      });

      if (response?.data) {
        const updatedUser = response.data.user;
        if (updatedUser) {
          Swal.fire({ icon: 'success', text: response.data.message, timer: 1600, showConfirmButton: false, customClass: { popup: 'sweetalert2-custom-popup' } });
          updateUserContext(updatedUser);
          localStorage.setItem('user', JSON.stringify(updatedUser));
          handleUserChange?.(updatedUser);
        } else {
          Swal.fire({ icon: 'warning', text: response.data.message || 'Unable to update profile.', confirmButtonText: 'OK', customClass: { popup: 'sweetalert2-custom-popup' } });
        }
        resetForm();
        navigate('/dashboard');
      } else {
        Swal.fire({ icon: 'warning', text: response?.error?.data || 'Unable to update profile.', confirmButtonText: 'OK', customClass: { popup: 'sweetalert2-custom-popup' } });
      }

      setTimeout(() => setSubmitting(false), 300);
    },
    validate: (values) => {
      const errors = {};
      if (!values.name) errors.name = 'Name is required';
      if (!values.family) errors.family = 'Family name is required';
      if (!values.email) errors.email = 'Email is required';
      if (!values.address) errors.address = 'Address is required';
      return errors;
    }
  });

  const fieldClass = (name) => `field ${form.errors[name] && form.touched[name] ? 'border-red-300 ring-4 ring-red-50' : ''}`;

  return (
    <section className="bg-surface py-12 sm:py-16">
      <div className="section-shell max-w-4xl">
        <div className="premium-card bg-white p-6 sm:p-8">
          <span className="eyebrow">Profile settings</span>
          <h1 className="section-title mt-5">Update your information</h1>
          <p className="section-copy">Keep your GoTrip profile accurate for smoother booking and support.</p>

          <form onSubmit={form.handleSubmit} className="mt-8 grid gap-5 sm:grid-cols-2">
            <label className="sm:col-span-1"><span className="mb-2 block text-xs font-bold uppercase tracking-wide text-muted">Name</span><input className={fieldClass('name')} name="name" value={form.values.name} onChange={form.handleChange} onBlur={form.handleBlur} /></label>
            <label className="sm:col-span-1"><span className="mb-2 block text-xs font-bold uppercase tracking-wide text-muted">Family</span><input className={fieldClass('family')} name="family" value={form.values.family} onChange={form.handleChange} onBlur={form.handleBlur} /></label>
            <label className="sm:col-span-2"><span className="mb-2 block text-xs font-bold uppercase tracking-wide text-muted">Email</span><input className={fieldClass('email')} name="email" type="email" value={form.values.email} onChange={form.handleChange} onBlur={form.handleBlur} /></label>
            <label className="sm:col-span-2"><span className="mb-2 block text-xs font-bold uppercase tracking-wide text-muted">Address</span><input className={fieldClass('address')} name="address" value={form.values.address} onChange={form.handleChange} onBlur={form.handleBlur} /></label>

            <div className="mt-4 space-y-2 text-sm text-red-500 sm:col-span-2">
              {form.errors.name && form.touched.name && <p>{form.errors.name}</p>}
              {form.errors.family && form.touched.family && <p>{form.errors.family}</p>}
              {form.errors.email && form.touched.email && <p>{form.errors.email}</p>}
              {form.errors.address && form.touched.address && <p>{form.errors.address}</p>}
            </div>

            <div className="flex justify-end gap-3 sm:col-span-2">
              <button type="button" onClick={() => window.history.back()} className="btn-secondary">Cancel</button>
              <button type="submit" disabled={form.isSubmitting} className="btn-primary">{form.isSubmitting ? 'Loading...' : 'Update profile'}</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
